import { render, staticRenderFns } from "./LeftAuth.vue?vue&type=template&id=16d89402&scoped=true&"
var script = {}
import style0 from "./LeftAuth.vue?vue&type=style&index=0&id=16d89402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d89402",
  null
  
)

export default component.exports